import React from 'react';
import './toggleButton.scss';

interface ToggleButtonProperties {
  id: string;
  label: string;
  onChange: (isChecked: boolean) => void;
  'data-on'?: string;
  isChecked: boolean;
  'data-off'?: string;
  description?: string;
  lableCustomClass?: string;
  isForEMI?: boolean;
  isLuxe?: boolean;
}

const ToggleButton: React.FC<ToggleButtonProperties> = props => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange && props.onChange(event.target.checked);
  };
  const labelId = `label-${props.id}`;
  const labelBy = labelId;
  const { lableCustomClass='' } = props;

  return (
    <label
      htmlFor={props.id}
      className={`switch ${props?.isForEMI ? 'switch-for-emi' : ''} ${
        props?.isLuxe ? 'switch-for-emi-luxe' : ''
      }`}
    >
      {props?.isForEMI && (
        <span id={labelId} className={lableCustomClass}>
          {props.label}
        </span>
      )}
      <input
        id={props.id}
        type="checkbox"
        role="switch"
        checked={props.isChecked}
        onChange={onChange}
        aria-checked={props.isChecked}
        aria-labelledby={labelBy}
      />
      {!props?.isForEMI && (
        <span id={labelId} className={lableCustomClass}>
          {props.label}
        </span>
      )}
    </label>
  );
};

ToggleButton.defaultProps = {
  'data-on': 'ON',
  'data-off': 'OFF'
};

export default ToggleButton;
